var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"layer-link",attrs:{"href":_vm.resolvedHref},on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }